/* tslint:disable:object-literal-shorthand */
import {MortgageContract, MortgageMonth} from '../../state/AppState';
import {Lazy} from '../utils/lazy';
import {lazyRnd} from '../utils/math';
import {Dynamiclist} from './dynamiclist';

export function interestZeroMonth(contract: MortgageContract): MortgageMonth {
  return {
    month: 0,
    newPrincipalPayment: 0,
    newInterestPayment: 0,
    currentTotalPrincipalPayment: 0,
    currentTotalInterestPayment: 0,
    currentTotalPremiumPayment: 0,
    currentRemainder: contract.mortgagedAmount,
    contract: contract,
    newPremiumPayment: 0
  } as MortgageMonth;
}

export function interestNextMonth(lastMonth: MortgageMonth, interestRate: Lazy<number>): MortgageMonth {
  const interestAmount = () => interestRate() * lastMonth.currentRemainder / 12.0 / 100.0;

  return {
    ...lastMonth,
    month: lastMonth.month + 1,
    currentRemainder: lastMonth.currentRemainder,
    newInterestPayment: interestAmount(),
    newPrincipalPayment: 0,
    newPremiumPayment: 0,
    currentTotalInterestPayment: lazyRnd(() => lastMonth.currentTotalInterestPayment + interestAmount())(),
  } as MortgageMonth;
}


export function calculateChain(interestRate: Lazy<number>): (lastMonth: MortgageMonth) => Dynamiclist<MortgageMonth> {
  return function calculate(lastMonth: MortgageMonth): Dynamiclist<MortgageMonth> {
    return () => {
      if (lastMonth.currentRemainder <= 0) {
        return null;
      } else {
        return {
          head: () => lastMonth,
          tail: (head: MortgageMonth = lastMonth) => calculate(interestNextMonth(head, interestRate))()
        };
      }
    }
  };
}
